import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { setParamToken, getUserToken, setDeployment } from "../../../Actions/Utils";
import { useNavigate } from "react-router-dom";

const Splash = () => {
    const [searchParams] = useSearchParams();
    const paramToken = searchParams.get("auth_token");
    const deployment = searchParams.get("deployment");
    const navigate = useNavigate();

    useEffect(() => {
        const token = getUserToken();
        if (token){
            navigate("/lang");
        } else if (paramToken) {
            setParamToken(paramToken);
            setDeployment(deployment);
            const timer = setTimeout(() => {
                navigate("/lang");
            }, 2000);
            return () => clearTimeout(timer);
        } else {
            const timer = setTimeout(() => {
                navigate("/lang");
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [paramToken, navigate]);


    return (
        <div
            style={{overflow: "scroll", backgroundImage: `url("/Assets/Images/wallpaperBg.jpg")` }}
            className={`bg-[var(--primary-dark-2)] h-screen w-screen flex items-center justify-center bg-blend-color-burn`}
        >
            <div className="flex flex-col items-center justify-center text-[2rem]">
                <img src={"/Assets/Images/Logo.svg"} alt="asha" />
            </div>
        </div>
    )
}

export default Splash;